<template>
  <div class="py-1">
    <div class="flex justify-center items-center">
      <div class="inline-flex p-1 bg-white rounded-full border shadow-sm border-gray-200 transition-all duration-300 ease-in-out">
        <button
          :class="[
            'py-1 px-3 rounded-full focus:outline-none transition-all duration-300 ease-in-out',
            isMonthly ? 'bg-blue-500 text-white' : 'text-gray-700'
          ]"
          @click="isMonthly = true"
        >
          Mensual
        </button>
        <button
          :class="[
            'py-1 px-3 rounded-full focus:outline-none transition-all duration-300 ease-in-out',
            !isMonthly ? 'bg-blue-500 text-white' : 'text-gray-700'
          ]"
          @click="isMonthly = false"
        >
          Anual
        </button>
      </div>
    </div>
    <!-- Plans -->
    <div class="py-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div v-for="plan in plans" :key="plan.id"
        class="rounded-3xl shadow-lg p-6 flex flex-col justify-between"
        :class="cardClassesForPlan(plan.kind)"
      >
        <div class="text-center">
          <h3 class="text-lg leading-6 font-medium" :class="fontColorForPlan(plan.kind, 'header')">{{plan.name}}</h3>
          <div class="mt-4 flex items-center justify-center text-4xl leading-none font-extrabold" :class="fontColorForPlan(plan.kind, 'header')">
            {{isMonthly? plan.monthly_price : plan.yearly_price}}<span v-if="plan.kind !== 'black'"
            class="ml-1 text-xl leading-8 font-medium text-gray-500">/{{pricePeriod}}
            </span>
          </div>
          <div class="mt-6">
            <button v-if="(!plan.selected || isOnTrial) && plan.change_cta.action === 'modal_confirmation' && plan.kind === 'normal'"
              class="w-full bg-white border border-indigo-600 text-indigo-600 font-semibold py-2 rounded-3xl hover:bg-indigo-50"
              :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
              :disabled="isLoading"
              @click="onChangePlanConfirmation(plan)"
            >
              {{plan.change_cta.name}}
            </button>

            <button v-else-if="(!plan.selected || isOnTrial) && plan.change_cta.action === 'modal_confirmation' && plan.kind === 'important'"
              class="w-full bg-indigo-600 text-white font-semibold py-2 rounded-3xl hover:bg-indigo-500"
              :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
              :disabled="isLoading"
              @click="onChangePlanConfirmation(plan)"
            >
              {{plan.change_cta.name}}
            </button>

            <button v-else-if="(!plan.selected || isOnTrial) && plan.change_cta.action === 'reamaze'" class="w-full bg-gray-700 text-white font-semibold py-2 rounded-3xl hover:bg-gray-600" data-reamaze-lightbox="contact">
              {{plan.change_cta.name}}
            </button>

            <button v-else class="w-full bg-white border border-indigo-600 text-indigo-600 font-semibold py-2 rounded-3xl hover:bg-indigo-50 opacity-50 cursor-not-allowed" disabled>
              Plan actual
            </button>
          </div>
        </div>
        <div v-for="feature in plan.features" :key="feature._id" class="mt-8">
          <h4 class="text-sm font-medium" :class="fontColorForPlan(plan.kind, 'header')">{{feature.name}}</h4>
          <ul class="mt-4 space-y-2">
            <li v-for="item in feature.items" :key="item._id" class="flex justify-between">
              <span :class="fontColorForPlan(plan.kind, 'inner')">{{item.name}}</span>
              <svg v-if="item.value === 'available'" class="h-5 w-5" :class="fontColorForPlan(plan.kind, 'checkmark')" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span v-else-if="item.value ==='unavailable'">—</span>
              <span v-else :class="fontColorForPlan(plan.kind, 'header')">{{item.value}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <lmConfirmationModal
      ref="lmConfirmationPlanUpgrade" title="Confirmar Cambio de Plan"
    />
  </div>
</template>

<script>
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import { mapActions, mapGetters } from 'vuex'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { EventBus } from '@/event-bus.js'

export default {
  mixins: [lmToasts],
  components: {
    lmConfirmationModal
  },
  data () {
    return {
      isMonthly: true,
      isLoading: false
    }
  },
  props: {
    plans: {
      type: 'array',
      default: []
    }
  },
  computed: {
    ...mapGetters('session', ['accountUserName', 'emailWasConfirmed', 'isOnTrial', 'daysLeft']),
    pricePeriod () {
      return this.isMonthly ? 'mes' : 'año'
    }
  },
  methods: {
    ...mapActions('session', ['getUserInfo']),
    async onChangePlanConfirmation (plan) {
      try {
        this.isLoading = true
        this.$refs['lmConfirmationPlanUpgrade'].setMessageProps(`¿Estás seguro de que querés cambiar al plan "${plan.name}"? Este cambio puede afectar tus límites y características disponibles.`)
        await this.$refs['lmConfirmationPlanUpgrade'].lmShow()
        await commonsApi.axiosPutWrapper(`/customer/plans/change/${plan.id}`, this.settings)
        this.$emit('reload')
        await this.getUserInfo()
        EventBus.$emit('congratsWithConfetti')
        this.lmToastSuccessMessage(`Te cambiaste al plan "${plan.name}", lo verás reflejado en tu próxima factura.`, 'Plan actualizado.')
      } catch (error) {

      } finally {
        this.isLoading = false
      }
    },
    cardClassesForPlan (kind) {
      if (kind === 'important') {
        return 'bg-gray-50 border-2 border-indigo-600'
      } else if (kind === 'black') {
        return 'bg-black border-gray-800'
      } else {
        return 'border border-gray-200'
      }
    },
    fontColorForPlan (kind, type) {
      if (kind === 'black') {
        return 'text-white'
      } else {
        if (type === 'header') {
          return 'text-gray-900'
        } else if (type === 'checkmark') {
          return 'text-indigo-600'
        }
      }
    }
  }
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
